import { render } from "./inputs.vue?vue&type=template&id=3233d741"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__